<template>
  <div class="popup_wrap">
    <div class="popup_box">
      <div class="store_title">매장 선택</div>
      <ul class="store_list">
        <li v-for="(restaurant) in restaurantList" :key="restaurant.idx">
          <div @click="selectRestaurant(restaurant)">
            {{restaurant.name}}
            <span>idx: {{restaurant.idx}}</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { renewalOtpNumber } from '../utills'

export default {
  name: 'restaurantSelectPopup',
  props: {
    restaurantList: Array
  },
  methods: {
    selectRestaurant (restaurant) {
      this.$store.commit('setStoreIdx', restaurant.idx)
      this.$store.dispatch('setRestaurant', restaurant.idx).then(() => {
        renewalOtpNumber()
        this.$router.push('/')
      }).catch((err) => {
        console.error(err)
      })
    }
  }
}
</script>
<style scoped lang="scss">
@import "@/assets/base.scss";

.popup_wrap {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 999;
  background: rgba(0, 0, 0, 0.6);

  .popup_box {
    position: absolute;
    width: 79.6875vw;
    height: 77.25vh;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    background: $white;
    box-shadow: 0 0.375vh 1.125vh 0 #00000080;
    border-radius: 1.5vh;
    padding: 3.75vh;
    box-sizing: border-box;

    .store_title {
      font-size: 36px; // IE11 fallback
      font-size: unquote("min(2.8125vw, 36px)");
      font-weight: bold;
      color: $black;
      padding-bottom: 3.75vh;
    }

    .store_list {
      padding: 0.625vh;
      height: 61.875vh;
      overflow: hidden;
      overflow-y: scroll;
      li {
        height: 9vh;
        line-height: 9vh;
        background: #f3f3f3;
        font-size: 30px; // IE11 fallback
        font-size: unquote("min(2.34375vw, 30px)");
        color: $black;
        padding: 0 2.34375vw;
        box-sizing: border-box;
        margin-bottom: 3.75vh;
        box-shadow: 0 0.375vh 1.125vh 0 #00000080;
        border-radius: 4.5vh;

        &:last-child {
          margin-bottom: 0;
        }
        span {
          float: right;
        }
      }
    }
  }
}
</style>
